/** Near-black or white, whichever reads better on `hex`. Undefined for anything but #rgb / #rrggbb. */
export function textOn(hex: string): string | undefined {
  const m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim())
  if (!m) return undefined
  const h = m[1].length === 3 ? [...m[1]].map((c) => c + c).join('') : m[1]
  const ch = (i: number) => {
    const c = parseInt(h.slice(i, i + 2), 16) / 255
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
  }
  const lum = 0.2126 * ch(0) + 0.7152 * ch(2) + 0.0722 * ch(4)
  // Contrast against white vs against near-black (#09090b, luminance ~0.003).
  return (1.05 / (lum + 0.05)) >= ((lum + 0.05) / 0.053) ? '#ffffff' : '#09090b'
}
